/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../img/logo.svg";
import { Component } from "react";
import SignedInLink from "./SignedInLink";
import SignedOutLink from "./SignedOutLink";
import { MdDehaze } from "react-icons/md";
import { connect } from "react-redux";


const menuBrekPoint = "700px";

const header = css`
  background-color: #040404;
  padding-left: 40px;
  svg#svg-logo {
    margin: 5px;
    width: 180px;
    .st0 {
      fill: #adb2bd;
      stroke: #adb2bd;
      stroke-width: 0.7555;
      stroke-miterlimit: 10;
    }
    .st1 {
      fill: #adb2bd;
    }
    .st2 {
      font-family: "Impact";
    }
    .st3 {
      font-size: 25.0985px;
    }
  }
`;

const nav = css`
  display: flex;
  justify-content: space-between;
  position: relative;
  ul {
  }
`;

const nav__list_close = `
   &#closed {
     right: -300px;
   } 
`;

const nav__list = css`
  list-style: none;
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;

  a {
    padding: 5px 15px;
    color: #fff !important;
    position: relative;
    transition: all 0.3s;
    &::after {
      display: block;
      position: absolute;
      bottom: 0;
      content: "";
      transform: scaleX(0);
      width: 100%;
      height: 1px;
      background-color: #f7c02d;
    }
    &:hover {
      color: #f7c02d !important;
      &::after {
        transform: scaleX(1);
        transition: all 0.3s;
      }
    }
  }

  @media (max-width: ${menuBrekPoint}) {
    display: block;
    padding-top: 40px;
    height: 100%;
    width: 300px;
    position: fixed;
    background: rgba(4, 4, 4, 0.8);
    right: 0;
    top: 0;
    z-index: 100;
    transition: all 0.5s;
    li {
      padding-top: 20px;
    }

    ${nav__list_close}
  }
`;

const button_close = css`
  visibility: hidden;
  display: block;
  width: 30px;
  height: 30px;
  display: block;
  position: relative;
  z-index: 101;
  margin-bottom: 25px;
  color: #fff !important;
  &:hover {
    cursor: pointer;
    &::before,
    &::after {
      background-color: #f7c02d;
    }
  }
  ::before,
  ::after {
    content: "";
    width: 2px;
    height: 30px;
    position: absolute;
    right: 14px;
    top: 0;
    background-color: #fff;
    transform: rotate(45deg);
  }
  ::after {
    transform: rotate(-45deg);
  }

  @media (max-width: ${menuBrekPoint}) {
    visibility: visible;
  }
`;

const button_open = css`
  &#btn_open {
    visibility: hidden;
    position: absolute;
    right: 52px;
    font-size: 40px;
    color: #fff;
    width: 30px;
    &:hover {
      color: #f7c02d;
      cursor: pointer;
    }
  }

  @media (max-width: ${menuBrekPoint}) {
    &#btn_open {
      visibility: visible;
    }
  }
`;

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      navOpen: false
    };
  }

  componentDidMount() {
    document.addEventListener("click", this.closeMenuOnClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.closeMenuOnClick);
  }

  toggleMenu = () => {
    this.setState({
      navOpen: !this.state.navOpen
    });
  };

  setNavRef = node => {
    this.NavRef = node;
  };

  closeMenuOnClick = event => {
    if (!this.NavRef.contains(event.target) && this.state.navOpen) {
      this.setState({
        navOpen: false
      });
    }
  };

  render() {

    const { auth, profile, noLinks } = this.props;

    const links = noLinks ? null : auth.uid ? (
      <SignedInLink profile={profile} />
    ) : (
        <SignedOutLink />
      );

    return (
      <header css={header}>
        <nav css={nav} ref={this.setNavRef}>
          <Link to="/">
            <Logo />
          </Link>
          <ul css={nav__list} id={!this.state.navOpen ? "closed" : "open"}>
            <li>
              <span
                css={button_close}
                id="btn_close"
                onClick={this.toggleMenu}
              />
            </li>
            <li>
              <Link to="/">ГЛАВНАЯ</Link>
            </li>
            {links}
          </ul>
          {!this.state.navOpen ? <span css={button_open} id="btn_open">
            <MdDehaze onClick={this.toggleMenu} />
          </span> : <span css={button_open} id="btn">
              <MdDehaze onClick={this.toggleMenu} />
            </span>}
        </nav>
      </header>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(Header);
